// eslint-disable-next-line import/prefer-default-export
export enum LOAD_PAYSLIPS {
	START = 'LOAD_PAYSLIPS_START',
	DONE = 'LOAD_PAYSLIPS_DONE',
	FAILED = 'LOAD_PAYSLIPS_FAILED'
}

export enum LOAD_PAYSLICES_USER {
	START = 'LOAD_PAYSLICES_USER_START',
	DONE = 'LOAD_PAYSLICES_USER_DONE',
	FAILED = 'LOAD_PAYSLICES_USER_FAILED'
}

export enum CREATE_PAYSLICES_USER {
	START = 'CREATE_PAYSLICES_USER_START',
	DONE = 'CREATE_PAYSLICES_USER_DONE',
	FAILED = 'CREATE_PAYSLICES_USER_FAILED'
}
